import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FxVideoCompressModalComponent} from '../fx-video-compress-modal/fx-video-compress-modal.component';
import {DwModalRef} from 'ng-quicksilver';
import {DwUserService} from '@webdpt/framework';
import {FxFfmpegUtilService} from '../fx-ffmpeg-util.service';
import {FFmpegConf} from '../ffmpeg-conf';

@Component({
  selector: 'app-fx-video-compress-modal-lite',
  templateUrl: './fx-video-compress-modal-lite.component.html',
  styleUrls: ['./fx-video-compress-modal-lite.component.less'],
  encapsulation: ViewEncapsulation.None,
})
export class FxVideoCompressModalLiteComponent extends FxVideoCompressModalComponent implements OnInit {
  // public progress = 0;

  constructor(
    private _modal: DwModalRef,
    public ffmpegUtilService: FxFfmpegUtilService,
  ) {
    super(_modal, ffmpegUtilService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.ffmpegUtilService.setLogHandler(this._onLog);
    this.ffmpegUtilService.setProgressHandler(this._onProgress);
    this.ffmpegUtilService.transcode().then(() => {
      console.log('transcode finished');
      this.confirm();
    });
  }

  private _onLog = (msg: string): void => {
    console.log(msg);
  }

  private _onProgress = ({ progress, time }): void => {
    // this.progress = progress * 100;
    // if (this.progress > 100) {}
  }

  public confirm = (): void => {
    console.log('confirm');
    this.ffmpegUtilService.uploadVideo().then((data: any) => {
      // console.log(data);
      this.uploadResponseData = data;
      this.modal.triggerOk();
    });
  }

  public cancel = (): void => {
    console.log('cancel');
    this.ffmpegUtilService.abort();
    this.modal.triggerCancel();
  }
}
